import {
  createMftpDirectoryService,
  createMftpOhifService,
  createMftpService,
  createMftpStudyService,
} from '@singular-health/services';
import type { App, Plugin } from 'vue';
import { MFTP_DIRECTORY_SERVICE_KEY, MFTP_OHIF_SERVICE_KEY, MFTP_SERVICE_KEY, MFTP_STUDY_SERVICE_KEY } from '../keys';

const DEFAULT_REGION = 'ap-southeast-2';
const DEFAULT_DOMAIN = 'mftp.shg.health';

export function createMftpPlugin(environment: 'test' | 'staging' | ''): Plugin {
  return {
    install(app: App) {
      const config = { environment, defaultRegion: DEFAULT_REGION, domain: DEFAULT_DOMAIN };
      app.provide(MFTP_SERVICE_KEY, createMftpService(config));
      app.provide(MFTP_DIRECTORY_SERVICE_KEY, createMftpDirectoryService(config));
      app.provide(MFTP_STUDY_SERVICE_KEY, createMftpStudyService(config));
      app.provide(MFTP_OHIF_SERVICE_KEY, createMftpOhifService(config));
    },
  };
}
